<p class="discography-intro">
  Russ played bass on every album below. Recordings span blues, jazz, swing, and
  Latin / international projects. This is a partial selection. Additional
  recordings across Russ's career aren't represented here. Stream any track
  inline.
</p>

@for (album of albums; track album.slug) {
  <section
    class="discography-album"
    [class.discography-album--live]="album.kind === 'live'"
    [attr.aria-labelledby]="album.slug + '-heading'"
  >
    <header class="discography-album__header">
      @if (album.coverImage) {
        <img
          class="discography-album__cover"
          [ngSrc]="'/images/discography/' + album.coverImage.filename"
          [width]="album.coverImage.width"
          [height]="album.coverImage.height"
          [alt]="'Cover art for ' + album.title + ' by ' + album.artist"
        />
      }
      @if (album.kind === "live") {
        <span class="discography-album__badge">Live recording</span>
      }
      <h2 [id]="album.slug + '-heading'" class="discography-album__title">
        {{ album.title }}
      </h2>
      <p class="discography-album__artist">
        {{ album.artist }}
        @if (album.releaseYear) {
          <span class="discography-album__year">· {{ album.releaseYear }}</span>
        }
      </p>
      @if (album.videoUrl) {
        <p class="discography-album__video-link">
          <a [href]="album.videoUrl" openNewTab>
            Watch the full concert on YouTube
          </a>
        </p>
      }
    </header>
    <ol class="discography-tracks">
      @for (track of album.tracks; track track.filename) {
        <li class="discography-track">
          <span class="discography-track__number">{{ track.number }}.</span>
          <span class="discography-track__title">{{ track.title }}</span>
          <audio
            controls
            preload="none"
            class="discography-track__player"
            [src]="'/audio/' + album.slug + '/' + track.filename"
            [attr.aria-label]="'Play ' + track.title + ' from ' + album.title"
          >
            Your browser does not support the audio element. Direct download:
            <a [href]="'/audio/' + album.slug + '/' + track.filename">
              {{ track.filename }}
            </a>
          </audio>
        </li>
      }
    </ol>
  </section>
}
